import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { BracniStatus } from './bracni-status';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-bracni-status-modal-update',
  templateUrl: './bracni-status-modal-update.component.html'  
})
export class BracniStatusModalUpdateComponent extends BaseModalUpdateComponent<BracniStatus> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<BracniStatus>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
